import script from "./TopMatter.vue?vue&type=script&setup=true&lang=ts"
export * from "./TopMatter.vue?vue&type=script&setup=true&lang=ts"

import "./TopMatter.vue?vue&type=style&index=0&id=6bb9ac94&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6bb9ac94"]])

export default __exports__